import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "farmer" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 0,
  class: "text-center no-wallet"
}
const _hoisted_4 = {
  key: 0,
  class: ""
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-col sm:flex-row justify-center" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center comic-panel blue-lightBlue"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text top-left" }, "Total Heroes Training", -1)
const _hoisted_9 = { class: "text-4xl farm-value" }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center comic-panel red-tomatoe"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text top-left" }, "Total Heroes Questing", -1)
const _hoisted_12 = { class: "text-4xl farm-value" }
const _hoisted_13 = {
  key: 2,
  class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center comic-panel blue-lightBlue"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text top-left" }, "Quest Duration", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-4xl farm-value" }, "30 Days", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center" }
const _hoisted_18 = {
  key: 3,
  class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center comic-panel yellow-orange"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text top-left" }, "Daily reward", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-4xl farm-value" }, "6 $GEMS", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 4,
  class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center comic-panel green-yellow"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text top-left" }, "Daily reward", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-4xl farm-value" }, "9 $GEMS", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 5,
  class: "flex flex-col w-full sm:w-96 text-center p-3 sm:p-1 justify-center comic-panel yellow-orange"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text top-left" }, "Heroes Return", -1)
const _hoisted_28 = {
  class: "text-4xl farm-value",
  id: "countdown"
}
const _hoisted_29 = { class: "claim-button-holder" }
const _hoisted_30 = { class: "claim-button-holder" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-full text-center mb-5",
  style: {"color":"black"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, "Hmm... not seen you around here before. Continue the setup to prove you're a champion")
], -1)
const _hoisted_33 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_Vault = _resolveComponent("Vault")!
  const _component_Quest = _resolveComponent("Quest")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ConfigPane),
      (!_ctx.wallet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Please connect wallet to access staking"))
        : _createCommentVNode("", true)
    ]),
    (!(!_ctx.wallet))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.farm == '5PvuwPLmDaoEyANf5C7SQvaQwjsEMTL8ofX8V85SDtfX')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.farmAcc.gemsStaked), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.farm == 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.farmAcc.gemsStaked), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.farm == 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.farm == '5PvuwPLmDaoEyANf5C7SQvaQwjsEMTL8ofX8V85SDtfX')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "quest-button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.farm = 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL'))
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.farm == 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "training-button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.farm = '5PvuwPLmDaoEyANf5C7SQvaQwjsEMTL8ofX8V85SDtfX'))
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.farm == '5PvuwPLmDaoEyANf5C7SQvaQwjsEMTL8ofX8V85SDtfX')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
                    : _createCommentVNode("", true),
                  (_ctx.farm == 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
                    : _createCommentVNode("", true),
                  (_ctx.farm == 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.getDateString(_ctx.farmerAcc.minStakingEndsTs)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.farm == '5PvuwPLmDaoEyANf5C7SQvaQwjsEMTL8ofX8V85SDtfX')
                  ? (_openBlock(), _createBlock(_component_Vault, {
                      key: _ctx.farmerAcc,
                      class: "mb-10",
                      vault: _ctx.farmerAcc.vault.toBase58(),
                      farm: _ctx.farm,
                      onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                      onUnstakeNft: _ctx.handleUnstakeNft,
                      onStakeNft: _ctx.handleStakeNft
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_29, [
                          (_ctx.farmerState === 'unstaked')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "begin-training-button",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.farmerState === 'staked')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "end-training-button",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.farmerState === 'pendingCooldown')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "end-training-button",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "claim-button",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["vault", "farm", "onSelectedWalletNft", "onUnstakeNft", "onStakeNft"]))
                  : _createCommentVNode("", true),
                (_ctx.farm == 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL')
                  ? (_openBlock(), _createBlock(_component_Quest, {
                      key: _ctx.farmerAcc,
                      class: "mb-10",
                      vault: _ctx.farmerAcc.vault.toBase58(),
                      farm: _ctx.farm,
                      farmerAcc: _ctx.farmerAcc,
                      onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                      onUnstakeNft: _ctx.handleUnstakeNft,
                      onStakeNft: _ctx.handleStakeNft
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          (_ctx.farmerState === 'unstaked')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "begin-quest-button",
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.farmerState === 'staked')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "end-quest-button",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.farmerState === 'pendingCooldown')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "end-quest-button",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "claim-button",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args)))
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["vault", "farm", "farmerAcc", "onSelectedWalletNft", "onUnstakeNft", "onStakeNft"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.farm == '5PvuwPLmDaoEyANf5C7SQvaQwjsEMTL8ofX8V85SDtfX')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "rounded bg-light py-2 px-4 mr-2",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.farm = 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL'))
                      }, " Go Adventuring and Questing "))
                    : _createCommentVNode("", true),
                  (_ctx.farm == 'G6h4J2acMoWZHVUrVo3GZ3k7Cz8ioYKmom53oc9BrKcL')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "rounded bg-light py-2 px-4 mr-2",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.farm = '5PvuwPLmDaoEyANf5C7SQvaQwjsEMTL8ofX8V85SDtfX'))
                      }, " Go Back to Training "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "rounded bg-light py-2 px-4 ml-2",
                    style: {"margin-bottom":"1.75rem"},
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " Setup ")
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}